import { FlowInterface } from '../flow-interface';
import { generateBuyLink, getPlanCategoryFromServiceCategory } from '../../helper/utils';

export default class BuyTrial extends FlowInterface {
  getCurrentParams() {
    const category = getPlanCategoryFromServiceCategory(this.serviceCategoryCode);

    return {
      ...this.getBuyNowParams(),
      plan: category,
      from: category,
    };
  }

  getLink() {
    return generateBuyLink(this.getCurrentParams());
  }

  getOptions() {
    return {
      disabled: !this.productEntryData?.currentUserHasPermission,
    };
  }
}
